import React from 'react';

import { ErrorComponent } from './ErrorComponent';

export interface ErrorBoundaryProps {
  readonly onCaughtError: (error: Error, errorInfo: React.ErrorInfo) => void;
  readonly errorComponent?: React.ComponentType<{}>;
}

interface ErrorBoundaryState {
  readonly hasErrored: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasErrored: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasErrored: true,
    };
  }

  public forceErrorUI() {
    this.setState({ hasErrored: true });
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.props.onCaughtError(error, errorInfo);
  }

  render() {
    const { errorComponent: CustomErrorComponent } = this.props;
    return !this.state.hasErrored ? this.props.children : CustomErrorComponent ? <CustomErrorComponent /> : <ErrorComponent />;
  }
}
